export default {
  firstName: {
    nl: 'Type hier je familienaam'
  },

  firstNameError: {
    nl: 'Voer een geldige familie naam in'
  },

  familyName: {
    nl: 'Familienaam'
  },

  familyNameError: {
    nl: 'Voer een geldige voornaam in'
  },

  familyMembers: {
    nl: 'Aantal familieleden'
  },

  familyMembersError: {
    nl: 'Min len 1 max 8'
  },

  nameAvatar: {
    nl: 'Naam familielid'
  },

  namePlaceholder: {
    nl: 'Type hier de naam'
  },

  nameAvatarError: {
    nl: 'Voer een geldige voornaam in'
  }
};
